let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7vntn")).then(() => parcelRequire('aI3LF'));